import { createContext, useContext, ReactNode } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { Tenant } from '@/types/crm';

interface TenantContextType {
  currentTenant: Tenant | null;
  isGreenvision: boolean;
  isGreenvisionCharging: boolean;
  canAccessAllData: boolean;
  canManageUsers: boolean;
}

const TenantContext = createContext<TenantContextType | undefined>(undefined);

export const TenantProvider = ({ children }: { children: ReactNode }) => {
  const { tenant, userRole } = useAuth();
  
  const currentTenant = tenant;
  
  const isGreenvision = currentTenant?.slug === 'greenvision';
  const isGreenvisionCharging = currentTenant?.slug === 'greenvision_charging';
  
  const canAccessAllData = isGreenvision && (
    userRole === 'super_admin' || 
    userRole === 'admin'
  );
  
  const canManageUsers = userRole === 'super_admin';
  
  return (
    <TenantContext.Provider 
      value={{
        currentTenant,
        isGreenvision,
        isGreenvisionCharging,
        canAccessAllData,
        canManageUsers
      }}
    >
      {children}
    </TenantContext.Provider>
  );
};

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenant must be used within TenantProvider');
  }
  return context;
};
